export const orderStatusArr = [
  {
    value: 0,
    label: '待付款',
    count: 0
  },
  {
    value: 6,
    label: '付款审核',
    count: 0
  },
  {
    value: 9,
    label: '待收货',
    count: 0
  },
  {
    value: 3,
    label: '已完成'
  },
  {
    value: 4,
    label: '已取消'
  }
];
export const payList = [
  {
    value: 0,
    label: '全部'
  },
  {
    value: 2,
    label: '微信'
  },
  {
    value: 4,
    label: '对公转账'
  },
  {
    value: 1,
    label: '支付宝'
  },
  {
    value: 3,
    label: '云闪付'
  }
]
export const titleList = [
  {
    name: '商品',
    width: 309
  },
  {
    name: '单价',
    width: 110
  },
  {
    name: '数量',
    width: 70
  },
  {
    name: '实付款',
    width: 110
  },
  {
    name: '支付方式',
    width: 100,
    list: payList
  },
  {
    name: '订单状态',
    width: 110,
  },
  {
    name: '操作',
    width: 100
  }
]
export const timeList = [
  {
    value: '',
    label: '全部'
  },
  {
    value: 1,
    label: '近三个月内订单'
  },
  {
    value: 2,
    label: '近半年内订单'
  },
  {
    value: 3,
    label: '今年内订单'
  },
  {
    value: 4,
    label: '今年以前订单'
  }
]

